export { badgeSizes } from '@sberdevices/plasma-core';
export type { BadgeSize } from '@sberdevices/plasma-core';

export { Badge, badgeViews } from './Badge';
export type { BadgeProps, BadgeView } from './Badge';
